module.exports = {
  siteTitle: 'Shane Schmaltz Personal Site', // <title>
  shortSiteTitle: 'ShaneSchmaltz.com', // <title> ending for posts and pages
  siteDescription:
    "Hey I'm Shane Schmaltz, full stack developer with a special interest in web development and internet marketing / branding. Software developer in Calgary Alberta Canada.",
  siteUrl: 'https://shaneschmaltz.com',
  siteLanguage: 'en',

  /* author */
  authorName: 'Shane Schmaltz',
  authorTwitterAccount: 'shane_schmaltz',

  /* manifest.json */
  manifestName: 'Shane Schmaltz - Software Developer',
  manifestStartUrl: '/index.html',
  manifestBackgroundColor: '#202121',
  manifestThemeColor: '#202121',
  manifestDisplay: 'minimal-ui',

  // social
  authorSocialLinks: [
    { name: 'github', url: 'https://github.com/stschmaltz' },
    { name: 'twitter', url: 'https://twitter.com/shane_schmaltz' },
    { name: 'linkedIn', url: 'https://www.linkedin.com/in/stschmaltz/' },
  ],
}
